import React from "react";
import { LAST_DELIVERY_COLOR, NON_FLEX_IN_TRANSIT_COLOR, ROUTE_LINE_COLOR, STATUS_COLORS } from "./shipmentMarkers";
import type { TowerShipment } from "../../../types/controlTower";

// Referencias del mapa del chofer: estados (o el recorrido), los de días
// anteriores y, a la derecha, la hora de la última entrega.
// withPending: con el recorrido también se ven los envíos que faltan visitar.
// showPendingStatus: "Pendiente" solo aparece si hay alguno (en el día casi
// no quedan: la operación los pasa a En camino).
export default function MapLegend({
  route,
  withPending = false,
  showPendingStatus = false,
  showRescheduled = false,
  showPrevious,
  lastDelivery,
  lastDeliveryLocated,
}: {
  route: boolean;
  withPending?: boolean;
  showPendingStatus?: boolean;
  // Hay reprogramados en el mapa (se pintan en gris).
  showRescheduled?: boolean;
  showPrevious: boolean;
  lastDelivery: TowerShipment | null;
  lastDeliveryLocated: boolean;
}) {
  if (route)
    return (
      <div className="tower-map-legend" aria-label="Referencias del recorrido">
        <span>
          <i style={{ background: STATUS_COLORS.delivered }} />
          Entregado
        </span>
        <span title="Nadie, ausente, no entregado o demorado.">
          <i style={{ background: STATUS_COLORS.incident }} />
          Visita sin entrega
        </span>
        <span title="Reprogramado (por el comprador, por Meli o sin motivo).">
          <i style={{ background: STATUS_COLORS.other }} />
          Reprogramado
        </span>
        <span>
          <i style={{ background: ROUTE_LINE_COLOR, height: 3, borderRadius: 2 }} />
          Orden de las visitas
        </span>
        {withPending && (
          <>
            <span>
              <i style={{ background: STATUS_COLORS.inTransit }} />
              En camino Flex
            </span>
            <span>
              <i style={{ background: NON_FLEX_IN_TRANSIT_COLOR }} />
              En camino particular
            </span>
            {showPendingStatus && (
              <span>
                <i style={{ background: STATUS_COLORS.pending }} />
                Pendiente
              </span>
            )}
          </>
        )}
      </div>
    );
  return (
    <div className="tower-map-legend" aria-label="Estados de los marcadores">
      <span>
        <i style={{ background: STATUS_COLORS.inTransit }} />
        En camino Flex
      </span>
      <span>
        <i style={{ background: NON_FLEX_IN_TRANSIT_COLOR }} />
        En camino particular
      </span>
      <span>
        <i style={{ background: STATUS_COLORS.delivered }} />
        Entregado
      </span>
      {showPendingStatus && (
        <span>
          <i style={{ background: STATUS_COLORS.pending }} />
          Pendiente
        </span>
      )}
      <span title="Nadie, ausente, no entregado o demorado.">
        <i style={{ background: STATUS_COLORS.incident }} />
        Nadie en el domicilio
      </span>
      {showRescheduled && (
        <span title="Reprogramado (por el comprador, por Meli o sin motivo).">
          <i style={{ background: STATUS_COLORS.other }} />
          Reprogramado
        </span>
      )}
      {showPrevious && (
        <span title="El envío sigue con el chofer desde otro día y hoy no tuvo movimiento. El color es el de su estado.">
          <i className="tower-legend-previous">↺</i>
          De días anteriores
        </span>
      )}
      {lastDelivery && (
        <span className="tower-legend-last" title="Última entrega registrada del chofer hoy.">
          <i style={{ background: LAST_DELIVERY_COLOR, border: "2px solid #fff", boxSizing: "border-box" }} />
          Última entrega <b>{lastDelivery.stateDate?.slice(11) || "sin hora"}</b>
          {!lastDeliveryLocated && " · sin ubicación"}
        </span>
      )}
    </div>
  );
}
